import AuthService from "../Auth/AuthService";
import PermissionFeature from "../Permissions/PermissionFeature";

/**
 * Registration permission utilities for admin features
 */
export default {
    /**
     * Check if user has Super Admin permission (can register anyone for any event)
     * @returns {boolean}
     */
    canRegisterForOthersAsSuper() {
        return AuthService.canView(PermissionFeature.REGSuperAdmin);
    },

    /**
     * Check if user has Basic Admin permission (can register others for events they created)
     * @returns {boolean}
     */
    canRegisterForOthersAsBasic() {
        return AuthService.canView(PermissionFeature.REGBasicAdmin);
    },

    /**
     * Check if user can register on behalf of others (either Super or Basic Admin)
     * @returns {boolean}
     */
    canRegisterForOthers() {
        return this.canRegisterForOthersAsSuper() || this.canRegisterForOthersAsBasic();
    },

    /**
     * Check if user can register a specific member for a specific event
     * @param {number} eventCreatorId - ID of the member who created the event
     * @param {number} targetMemberId - ID of the member to register
     * @returns {boolean}
     */
    canRegisterMemberForEvent(eventCreatorId, targetMemberId) {
        const currentUserId = AuthService.getCurrentUserId();

        // If registering themselves, always allowed
        if (targetMemberId === currentUserId) {
            return true;
        }

        // Super Admin can register anyone
        if (this.canRegisterForOthersAsSuper()) {
            return true;
        }

        // Basic Admin can only register others for events they created
        if (this.canRegisterForOthersAsBasic() && eventCreatorId === currentUserId) {
            return true;
        }

        return false;
    },

    /**
     * Get the current user's registration admin level
     * @returns {string} 'super' | 'basic' | 'none'
     */
    getRegistrationAdminLevel() {
        if (this.canRegisterForOthersAsSuper()) {
            return 'super';
        }
        if (this.canRegisterForOthersAsBasic()) {
            return 'basic';
        }
        return 'none';
    }
};


